import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();
const legacyAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
const clientKey = publishableKey || legacyAnonKey;

export const isSupabaseConfigured = Boolean(url && clientKey);

export const supabase = isSupabaseConfigured
  ? createClient(url, clientKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export const supabaseProjectUrl = url || "";
